namespace TabAurous.Inventory {
    export namespace ConvertToWIPItemsService {
        export const baseUrl = 'Inventory/ConvertToWIPItems';

        export declare function Create(request: Serenity.SaveRequest<ConvertToWIPItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ConvertToWIPItemsRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ConvertToWIPItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ConvertToWIPItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "Inventory/ConvertToWIPItems/Create",
            Update = "Inventory/ConvertToWIPItems/Update",
            Delete = "Inventory/ConvertToWIPItems/Delete",
            Retrieve = "Inventory/ConvertToWIPItems/Retrieve",
            List = "Inventory/ConvertToWIPItems/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ConvertToWIPItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
